"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDurationParts = void 0;
function getDurationParts(duration) {
    return {
        hours: Math.floor(duration / 60),
        minutes: duration % 60
    };
}
exports.getDurationParts = getDurationParts;
//# sourceMappingURL=getDurationParts.js.map